"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clamp;
/**
 * Clamp a value between a min and max value
 * @ignore
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
module.exports = exports["default"];
//# sourceMappingURL=clamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-input-range/lib/js/utils/clamp.js
// module id = 810
// module chunks = 95715928098905 168707334958949